export let STREAM_STATUSES;
(function (STREAM_STATUSES) {
  STREAM_STATUSES["READY"] = "READY";
  STREAM_STATUSES["PENDING"] = "PENDING";
})(STREAM_STATUSES || (STREAM_STATUSES = {}));
export let LIVE_VIDEO_STATUS;
(function (LIVE_VIDEO_STATUS) {
  LIVE_VIDEO_STATUS["READY"] = "IN_PROGRESS";
  LIVE_VIDEO_STATUS["PENDING"] = "PENDING";
  LIVE_VIDEO_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
  LIVE_VIDEO_STATUS["SCHEDULED"] = "SCHEDULED";
  LIVE_VIDEO_STATUS["FINISHED"] = "FINISHED";
})(LIVE_VIDEO_STATUS || (LIVE_VIDEO_STATUS = {}));
//# sourceMappingURL=live-statuses.js.map